/**
 * The capsule drawn as a small chest: closed with a padlock while the time lock holds, open with
 * the letter showing once the capsule has been opened. Decorative; the text next to it says the same.
 */
export function Chest({ open, size = 72 }: { open: boolean; size?: number }) {
  return (
    <svg className={`chest ${open ? "chest-open" : "chest-closed"}`} viewBox="0 0 64 60" width={size} height={size * 60 / 64} aria-hidden="true">
      {open ? (
        <>
          <ellipse className="chest-glow" cx="32" cy="24" rx="26" ry="14" />
          <path className="chest-inside" d="M8 33 12 13h40l4 20Z" />
          <path className="chest-rim" d="M12 13h40" />
          <g className="chest-letter">
            <rect x="19" y="18" width="26" height="18" rx="1.5" transform="rotate(-6 32 27)" />
            <path d="m19.5 19.5 12.5 9 12.5-11" transform="rotate(-6 32 27)" />
          </g>
          <rect className="chest-wood" x="8" y="33" width="48" height="23" rx="2" />
          <rect className="chest-band" x="15" y="33" width="4" height="23" />
          <rect className="chest-band" x="45" y="33" width="4" height="23" />
          <path className="chest-shackle" d="M28 38v-6a4 4 0 0 1 8 0" />
          <rect className="chest-metal" x="26" y="38" width="12" height="10" rx="1.5" />
        </>
      ) : (
        <>
          <path className="chest-wood" d="M8 27v-7a11 11 0 0 1 11-11h26a11 11 0 0 1 11 11v7Z" />
          <rect className="chest-wood" x="8" y="27" width="48" height="29" rx="2" />
          <path className="chest-seam" d="M8 27h48" />
          <rect className="chest-band" x="15" y="9.5" width="4" height="46.5" />
          <rect className="chest-band" x="45" y="9.5" width="4" height="46.5" />
          <path className="chest-shackle" d="M28 30v-4a4 4 0 0 1 8 0v4" />
          <rect className="chest-metal" x="26" y="30" width="12" height="11" rx="1.5" />
          <path className="chest-keyhole" d="M32 33.5v3.5" />
        </>
      )}
    </svg>
  );
}
